var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectNv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8775 14.0908C44.3326 14.8001 44.3861 16.854 42.97 17.6382L25.9272 27.0756C24.7288 27.7392 23.2742 27.7434 22.0721 27.0868L5.34599 17.9512C3.93682 17.1815 3.96341 15.1488 5.39222 14.4162L22.2082 5.79457C23.3287 5.22011 24.6542 5.20675 25.786 5.75851L42.8775 14.0908ZM42.0011 15.8885L24.9096 7.55626C24.3437 7.28038 23.6809 7.28706 23.1207 7.57429L6.30469 16.1959L23.0308 25.3315C23.6318 25.6598 24.3591 25.6577 24.9583 25.3259L42.0011 15.8885Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8775 22.0908C44.3326 22.8001 44.3861 24.854 42.97 25.6382L25.9272 35.0756C24.7288 35.7392 23.2742 35.7434 22.0721 35.0868L5.34599 25.9512C3.93682 25.1815 3.96341 23.1488 5.39222 22.4162L11.5431 19.2626L12.4556 21.0423L6.30469 24.1959L23.0308 33.3315C23.6318 33.6598 24.3591 33.6577 24.9583 33.3259L42.0011 23.8885L35.8687 20.8989L36.7451 19.1011L42.8775 22.0908Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8775 30.0908C44.3326 30.8001 44.3861 32.854 42.97 33.6382L25.9272 43.0756C24.7288 43.7392 23.2742 43.7434 22.0721 43.0868L5.34599 33.9512C3.93682 33.1815 3.96341 31.1488 5.39222 30.4162L10.9496 27.5669L11.8621 29.3466L6.30469 32.1959L23.0308 41.3315C23.6318 41.6598 24.3591 41.6577 24.9583 41.3259L42.0011 31.8885L36.349 29.133L37.2254 27.3353L42.8775 30.0908Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectNv);
export default __webpack_public_path__ + "static/media/Project_nv.3f4a3cbc291a02a201cf961cdd38d331.svg";
export { ForwardRef as ReactComponent };